export enum BlogVariantEnum {
  Primary = 'Primary',
  PrimaryLight = 'PrimaryLight',
  PrimaryOutlined = 'PrimaryOutlined',
  Accent = 'Accent',
  NeutralOutlined = 'NeutralOutlined',
  Ghost = 'Ghost',
  Danger = 'Danger',
  SecondaryGreen = 'SecondaryGreen',
  SecondaryPurple = 'SecondaryPurple',
  Neutral = 'Neutral',
  White = 'White',
  WhiteOutlined = 'WhiteOutlined',
}

export type BlogVariantType = keyof typeof BlogVariantEnum;
